import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "container with--content-wide" };
import SiteSearch from '../../front/components/SiteSearch/SiteSearch.vue';
import { Search } from './Search';
import { theme } from '../../front/Theme';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SearchApp',
    props: {
        searchLayout: {}
    },
    setup(__props) {
        var _a, _b;
        const props = __props;
        const url = new URL(window.location.href);
        const maybeInitialIndexUid = (url.searchParams.get(Search.UriParam.IndexUid) || props.searchLayout.json.active_index_uid);
        const initialIndexUid = theme().json.meilisearch.indexes.some(i => i.uid === maybeInitialIndexUid)
            ? maybeInitialIndexUid
            : null;
        const initialTopicsIds = (((_a = url.searchParams.get(Search.UriParam.Topics)) === null || _a === void 0 ? void 0 : _a.split('-')) || []).map(v => parseInt(v)).filter(v => !isNaN(v));
        // TODO Restore facets more efficiently by storing them differently
        const initialStaticFacets = (((_b = url.searchParams.get(Search.UriParam.StaticFacets)) === null || _b === void 0 ? void 0 : _b.split('-')) || []);
        const initialDateFrom = url.searchParams.get(Search.UriParam.DateFrom);
        const initialDateTo = url.searchParams.get(Search.UriParam.DateTo);
        function onChange(args) {
            var _a, _b;
            const url = new URL(window.location.href);
            if (typeof args.indexUid !== 'undefined') {
                if (args.indexUid) {
                    url.searchParams.set(Search.UriParam.IndexUid, args.indexUid);
                }
                else if (url.searchParams.has(Search.UriParam.IndexUid)) {
                    url.searchParams.delete(Search.UriParam.IndexUid);
                }
            }
            if (typeof args.dateFrom !== 'undefined') {
                url.searchParams.set(Search.UriParam.DateFrom, (new Date(args.dateFrom)).toISOString().slice(0, 10));
            }
            if (typeof args.dateTo !== 'undefined') {
                url.searchParams.set(Search.UriParam.DateTo, (new Date(args.dateTo)).toISOString().slice(0, 10));
            }
            if (typeof args.query !== 'undefined') {
                url.searchParams.set(Search.UriParam.Query, args.query);
            }
            if ((_a = args.topicsIds) === null || _a === void 0 ? void 0 : _a.length) {
                url.searchParams.set(Search.UriParam.Topics, args.topicsIds.join(','));
            }
            else {
                url.searchParams.delete(Search.UriParam.Topics);
            }
            if ((_b = args.staticFacets) === null || _b === void 0 ? void 0 : _b.length) {
                // TODO Store facets more efficiently, by factoring out indexUid & attribute ID
                url.searchParams.set(Search.UriParam.StaticFacets, args.staticFacets.join(','));
            }
            else {
                url.searchParams.delete(Search.UriParam.StaticFacets);
            }
            if (url.href !== window.location.href) {
                window.history.replaceState({}, '', url.href);
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(SiteSearch, {
                    "initial-index-uid": _unref(initialIndexUid),
                    "initial-topics-ids": _unref(initialTopicsIds),
                    "initial-static-facets": _unref(initialStaticFacets),
                    "initial-date-from": _unref(initialDateFrom),
                    "initial-date-to": _unref(initialDateTo),
                    query: _ctx.searchLayout.json.query,
                    "auto-focus-input": true,
                    advanced: true,
                    onIndexChange: _cache[0] || (_cache[0] = ($event) => (onChange({ indexUid: $event }))),
                    onQueryChange: _cache[1] || (_cache[1] = ($event) => (onChange({ query: $event }))),
                    onTopicsChange: _cache[2] || (_cache[2] = ($event) => (onChange({ topicsIds: ($event === null || $event === void 0 ? void 0 : $event.map(t => parseInt(t.id))) || [] }))),
                    onStaticFacetsChange: _cache[3] || (_cache[3] = ($event) => (onChange({ staticFacets: $event || [] }))),
                    onDateFromChange: _cache[4] || (_cache[4] = ($event) => (onChange({ dateFrom: $event }))),
                    onDateToChange: _cache[5] || (_cache[5] = ($event) => (onChange({ dateTo: $event })))
                }, null, 8, ["initial-index-uid", "initial-topics-ids", "initial-static-facets", "initial-date-from", "initial-date-to", "query"])
            ]));
        };
    }
});
